import { render, staticRenderFns } from "./Solicitudes.vue?vue&type=template&id=e08ca358&scoped=true&"
import script from "./Solicitudes.vue?vue&type=script&lang=ts&"
export * from "./Solicitudes.vue?vue&type=script&lang=ts&"
import style0 from "./Solicitudes.vue?vue&type=style&index=0&id=e08ca358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08ca358",
  null
  
)

export default component.exports